import { markRaw } from 'vue'
import PopupAbstract from './PopupAbstract'
import PopupArea from './PopupArea.vue'

export default class PopupAreaService extends PopupAbstract {
  public name = 'PopupAreaService'
  protected component = markRaw(PopupArea)
}
